import { render } from "./FooterSection.vue?vue&type=template&id=96994b36"
const script = {}

import exportComponent from "/var/www/music-social-network/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__